import { Card } from 'reactstrap';
import InstitutionsTable from './parts/InstitutionsTable';
import InstitutionsFormLoader from './parts/Loaders/InstitutionsFormLoader';
import InstitutionsLoader from './parts/Loaders/InstitutionsLoader';

function Institutions() {
  return (
    <Card className="p-4">
      <InstitutionsFormLoader>
        <InstitutionsLoader>
          <InstitutionsTable />
        </InstitutionsLoader>
      </InstitutionsFormLoader>
    </Card>
  );
}
export default Institutions;
